<template>
  <div class="panel mb-4">
    <button
      @click="toggleAccordion()"
      class="flex flex-row items-center justify-between"
      :id="id"
      :aria-expanded="isOpen ? 'true' : 'false'"
      :aria-controls="contentId"
    >
      <slot name="title" />

      <svg
        class="w-3 transition-all duration-200 transform"
        :class="{
          'rotate-180': isOpen,
          'rotate-0': !isOpen,
        }"
        fill="none"
        stroke="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 10"
        aria-hidden="true"
      >
        <path
          d="M15 1.2l-7 7-7-7"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>

    <div class="content" :aria-hidden="!isOpen" :id="contentId" v-show="isOpen">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'accordion-panel',
  data() {
    return {
      isOpen: false,
    };
  },
  props: {
    ariaTitle: {
      type: String,
      required: true,
    },
  },
  computed: {
    id() {
      return this.ariaTitle.toLowerCase().replace(/\s+/g, '-');
    },
    contentId() {
      return `content-${this.id}`;
    },
  },
  methods: {
    toggleAccordion() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style lang="scss" scoped>
.panel {
  button {
    text-align: left;

    color: #626262;
    font-size: 1.2rem;
    font-weight: 400;

    width: 100%;
    padding: 10px;

    background: transparent;
    border: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.04);
  }

  .content {
    padding: 10px;
  }
}
</style>
